// Custom Theme

$( document ).ready(function() {
  $(window).on('load', function() {
    $('body').on('click', '.btn-enquire', function() {
      $('.cstm-form-wrapper .cstm-form').slideToggle();
    });
    var subject = $('.cstm-form-wrapper').attr('data-subject');
    console.log(subject);
    $('#subject-wrapper #subject').val(subject);
  });
});